import { Stacked, Typography } from '@statsbomb/kitbag-components';
import React, { ReactNode } from 'react';
import { FlagIcon } from '@/components/icons/FlagIcon';

const ExportHeaderRow = ({
  leftTitle,
  rightTitle,
  rightIcon,
  variant = 'headingMedium',
}: {
  leftTitle: string;
  rightTitle: string;
  rightIcon?: ReactNode;
  variant?: string;
}) => (
  <Stacked justifyContent="space-between">
    <Typography variant={variant}>{leftTitle}</Typography>
    {rightIcon ? (
      <Stacked alignItems="center">
        {rightIcon}
        <Typography variant={variant}>{rightTitle}</Typography>
      </Stacked>
    ) : (
      <Typography variant={variant}>{rightTitle}</Typography>
    )}
  </Stacked>
);

export const ExportComparisonHeader = ({
  title,
  comparisonTitle,
  comparisonCountryCode,
  primaryTeamInfo,
  comparisonTeamInfo,
  info1,
  info2,
  comparisonInfo1,
  comparisonInfo2,
  templateName,
  secondaryTitlePrefix,
}: {
  title: string;
  comparisonTitle: string;
  comparisonCountryCode?: string | null;
  primaryTeamInfo: string;
  comparisonTeamInfo: string;
  info1: string;
  info2: string;
  comparisonInfo1: string;
  comparisonInfo2: string;
  templateName: string;
  secondaryTitlePrefix: string;
}) => (
  <>
    <ExportHeaderRow
      leftTitle={title}
      rightTitle={comparisonTitle}
      rightIcon={comparisonCountryCode && <FlagIcon countryCode={comparisonCountryCode} naturalDimensions />}
      variant="headingLarge"
    />
    {(primaryTeamInfo || comparisonTeamInfo) && (
      <ExportHeaderRow leftTitle={primaryTeamInfo} rightTitle={comparisonTeamInfo} />
    )}
    <ExportHeaderRow leftTitle={info1} rightTitle={comparisonInfo1} />
    <ExportHeaderRow leftTitle={info2} rightTitle={comparisonInfo2} />
    {templateName && (
      <Stacked justifyContent="center" alignItems="baseline">
        {secondaryTitlePrefix && <Typography variant="headingMedium">{secondaryTitlePrefix}</Typography>}
        <Typography variant="bodyRegular">{templateName}</Typography>
      </Stacked>
    )}
  </>
);

export const ExportStandardHeader = ({
  title,
  templateName,
  secondaryTitlePrefix,
  firstSubtitle,
  secondSubtitle,
  thirdSubtitle,
}: {
  title: string;
  templateName: string;
  secondaryTitlePrefix: string;
  firstSubtitle?: string;
  secondSubtitle?: string;
  thirdSubtitle?: string;
}) => (
  <>
    <Typography variant="headingLarge">{title}</Typography>
    {templateName && (
      <Stacked alignItems="baseline">
        {secondaryTitlePrefix && <Typography variant="headingRegular">{secondaryTitlePrefix}</Typography>}
        <Typography variant="bodyRegular">{templateName}</Typography>
      </Stacked>
    )}
    {firstSubtitle && <Typography variant="headingMedium">{firstSubtitle}</Typography>}
    {secondSubtitle && <Typography variant="headingMedium">{secondSubtitle}</Typography>}
    {thirdSubtitle && <Typography variant="headingMedium">{thirdSubtitle}</Typography>}
  </>
);
